export type QuickReportItem = {
  id: string;
  label: string;
  description: string;
  tone: "blue" | "sky" | "green" | "amber" | "orange" | "purple";
  to?: string;
  reportId?: number;
  isNotHeadRole?: string;
};

export const EMPTY_REPORT_FILTER = {
  retreatId: 0,
  dateFrom: "",
  dateTo: "",
};

export const QUICK_REPORTS: QuickReportItem[] = [
  {
    id: "full-list",
    label: "Full List",
    description: "Open the complete couples directory.",
    tone: "blue",
    to: "/manageCouples",
  },
  {
    id: "last-two-years",
    label: "Participated In Last 2 Years",
    description: "Couples who attended a retreat in the last two years.",
    tone: "sky",
    reportId: 6,
  },
  {
    id: "served-team",
    label: "Served On Team",
    description: "Couples who have served on a retreat team.",
    tone: "green",
    reportId: 1,
  },
  {
    id: "never-team",
    label: "Never Served On Team",
    description: "Couples who have not yet served on a team.",
    tone: "amber",
    reportId: 2,
  },
  {
    id: "lead-couple",
    label: "Served As A Retreat Lead Couple",
    description: "Couples who have served as retreat lead.",
    tone: "purple",
    reportId: 8,
  },
  {
    id: "head-service",
    label: "Served As A Head Of Service",
    description: "Couples who have served as a head of service.",
    tone: "orange",
    reportId: 9,
  },
  {
    id: "never-head",
    label: "Never Served As A Head Of Service",
    description: "Couples who have not served as a head of service.",
    tone: "amber",
    reportId: 10,
    isNotHeadRole: "isNotHeadRole",
  },
  {
    id: "given-talk",
    label: "Given A Talk",
    description: "Couples who have given a retreat talk.",
    tone: "green",
    reportId: 3,
  },
  {
    id: "never-talk",
    label: "Never Given A Talk",
    description: "Couples who have not given a talk.",
    tone: "sky",
    reportId: 4,
  },
];
